define('MultiAddToCart.Scroll.Helper', [
    'Backbone',
    'underscore'
],
function MultiAddToCartScrollHelper(
    Backbone,
    _
) {
    'use strict';

    return {
        setUpScroll: function setUpScroll(view) {
            if (SC.isPageGenerator()) {
                return true;
            }

            if (view.$el.find('[data-view="Facets.Items"]').length) {
                view.$el.find('[data-view="Facets.Items"]')[0].dataset.scroll = 'start-floating';
                view.$el.find('[data-view="Facets.Items"]')[0].dataset.fixed = 'object';
            }

            // console.log('setUpScroll', view.$el.find('[data-view="Facets.Items"]'))

            // return the observers with targets.
            return this.scrollController(view);
        },

        scrollController: function scrollController(view) {
                var self = this;
                var $end;
                var $start;
                var containerIntersecting = false;
                var endIntersecting = false;

                if (SC.isPageGenerator()) {
                    return true;
                }

                if (view.$el.find('[data-scroll="end-floating"]') || view.$el.find('[data-scroll="start-floating"]')) {
                    $end = view.$el.find('[data-scroll="end-floating"]');
                    $start = view.$el.find('[data-scroll="start-floating"]');
                }

                this.observer = new IntersectionObserver(function IntersectionObserverConstructor(entries) {
                    var containerElement;
                    var endElement;

                    _(entries).each(function forEachEntry(entry) {
                        if (!entry || !entry.target) {
                            return;
                        }
                        switch (jQuery(entry.target).data('scroll')) {
                            case 'start-floating':
                                containerElement = entry;
                                break;
                            case 'end-floating':
                                endElement = entry;
                                break;
                            default:
                        }
                    });

                    if (containerElement) {
                        containerIntersecting = containerElement.isIntersecting;
                    }

                    if (endElement) {
                        endIntersecting = endElement.isIntersecting;
                    }

                    if (endIntersecting) {
                        // stop floating
                        self.endAddToCartFloating();
                    } else if (containerIntersecting) {
                        // start floating
                        self.startAddToCartFloating();
                    }
                    /* If observer needs to stop listening while going up use this.
                    else {

                        // stop floating
                        self.endAddToCartFloating();
                    }*/
                }, {
                    threshold: [0]
                });

                // Returns observer with targets to call method from mount to app.
                return {
                    observer: this.observer,
                    start: $start[0],
                    end: $end[0]
                }
        },

        startAddToCartFloating: function startAddToCartFloating() {
            if (!SC.isPageGenerator()) {
                jQuery('[data-fixed="object"]').addClass('floating-total');
            }
        },

        endAddToCartFloating: function endAddToCartFloating() {
            if (!SC.isPageGenerator()) {
                jQuery('[data-fixed="object"]').removeClass('floating-total');
            }
        },

        floatingListeners: Backbone.View.extend({
            template: function() {
                return '<div data-scroll="' + this.options.controllerAttr + '"></div>'
            }
        })
    }
});
